import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { QualifierValue } from '@app/app/interfaces/qualifier.model';
import { AttributesMap } from '@app/app/services/decisioning.service';

@Component( {
  selector: 'app-qualifier-values-table',
  templateUrl: 'qualifier-values-table.component.html',
  styleUrls: ['./qualifier-values-table.component.scss']
} )
export class QualifierValuesTableComponent implements OnInit {

  @Input() attributesMap: AttributesMap;
  @Input() qualifierValues: QualifierValue[];
  dataSource: MatTableDataSource<QualifierValue>;
  displayedColumns = [
    'qualifier',
    'requirement',
    'actual'
  ];

  constructor() {
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
    this.dataSource.data = this.qualifierValues;
  }
}
